export const initialValuesSearchItem = {
  bill_to: "",
  load_detail: "",
  load_address: "",
  unload_address: "",
  date_min: null,
  date_max: null,
  comment_invs: "",
  invoice_from: "", // time
  invoice_to: "", // time
};
